import { AssetInfo } from './../../../models/common';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';
import { ApiService } from 'src/app/providers/api.service';
import { Component, Inject, OnInit, OnDestroy, NgZone } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable, Subscription } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { BuisnessPromotion } from 'src/app/models/common';
import { TOUCH_BUFFER_MS } from '@angular/cdk/a11y';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import { Moment } from 'moment';
import { MatDatepicker } from '@angular/material/datepicker';
import * as moment from 'moment';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MatDatepickerModule} from '@angular/material/datepicker';

export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
@Component({
  selector: 'sm-add-employee-salary',
  templateUrl: './add-employee-salary.component.html',
  styleUrls: ['./add-employee-salary.component.scss'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ],
})
export class AddEmployeeSalaryComponent implements OnInit, OnDestroy {
  date = new FormControl();
  salaryData: any = []
  maxDate: Date = new Date()
  public newSalaryData: any = {
    hash_id:null,
    amount: null,
    workingDays: null,
    paidLeave: null,
    unPaidLeave: null,
    salaryType: 1,
    notes: null,
    salaryFromDate: null,
    salaryToDate: null,
    salary_credit_date: null,
    payType: 1,
    paidOn: 1,
    netPayment: null,
    otherPerks: null,
    perksType: null,
    deduction: null,
    deductionType: null,
  }
  public editCreditData: any = {
    amount: null,
    status: 1
  }
  public fileName: string = '';
  private _apiSubscription: Subscription = new Subscription();
  public editMode: boolean = false;
  public removable: boolean = true;
  public assetList: any[] = [];
  public loader: boolean = false;
  private _assetInfo: AssetInfo[] = [];
  constructor(
    @Inject(MAT_DIALOG_DATA) public parentData: any,
    private _apiService: ApiService,
    private _snackBar: MatSnackBar,
    private _ngZone: NgZone,
    private loaderservice: LoaderServiceService
  ) {}

  removeAsset(index: any) {
    console.log(index);
    this.assetList.splice(index, 1);
  }

  ngOnInit(): void {
    let data: any = new BuisnessPromotion();

    Object.assign(data, this.parentData.data);
    console.log(data);

      // this.newSalaryData = data;
      this.editMode = data.editMode;

      if(data.editMode){
        if(data.salaryData.paidOn ==1){
          this.newSalaryData.hash_id = data.salaryData.hash_id
          this.newSalaryData.amount = data.salaryData.amount
          this.newSalaryData.workingDays = data.salaryData.workingDays
          this.newSalaryData.paidLeave = data.salaryData.paidLeave
          this.newSalaryData.unPaidLeave = data.salaryData.unPaidLeave
          this.newSalaryData.salaryType = data.salaryData.salaryType
          this.newSalaryData.notes = data.salaryData.notes
          this.newSalaryData.salaryFromDate = data.salaryData.salaryFromDate
          this.newSalaryData.salaryToDate = data.salaryData.salaryToDate
          this.newSalaryData.salary_credit_date = data.salaryData.salaryCreditDate
          this.newSalaryData.payType = data.salaryData.payType
          this.newSalaryData.paidOn = data.salaryData.paidOn
          this.newSalaryData.netPayment = data.salaryData.netPayment
          this.newSalaryData.otherPerks = data.salaryData.otherPerks
          this.newSalaryData.deduction = data.salaryData.deduction
          this.newSalaryData.deductionType = data.salaryData.deduction_type
          this.newSalaryData.perksType = data.salaryData.perks_type
          this.changeRates()
        }
        else if(data.salaryData.paidOn ==2){
          this.newSalaryData.hash_id = data.salaryData.hash_id
          this.newSalaryData.amount = data.salaryData.amount
          this.newSalaryData.workingDays = data.salaryData.workingDays
          this.newSalaryData.paidLeave = data.salaryData.paidLeave
          this.newSalaryData.unPaidLeave = data.salaryData.unPaidLeave
          this.newSalaryData.salaryType = data.salaryData.salaryType
          this.newSalaryData.notes = data.salaryData.notes
          this.newSalaryData.salaryFromDate = data.salaryData.salaryFromDate
          this.newSalaryData.salaryToDate = data.salaryData.salaryToDate
          this.newSalaryData.salary_credit_date = data.salaryData.salaryCreditDate
          this.newSalaryData.payType = data.salaryData.payType
          this.newSalaryData.paidOn = data.salaryData.paidOn
          this.newSalaryData.netPayment = data.salaryData.netPayment
          this.newSalaryData.otherPerks = data.salaryData.otherPerks
          this.newSalaryData.deduction = data.salaryData.deduction
          this.newSalaryData.deductionType = data.salaryData.deduction_type
          this.newSalaryData.perksType = data.salaryData.perks_type
          this.changeRates()
        }
        else if(data.salaryData.paidOn ==3){
          this.newSalaryData.hash_id = data.salaryData.hash_id
          this.newSalaryData.amount = data.salaryData.amount
          this.newSalaryData.workingDays = data.salaryData.workingDays
          this.newSalaryData.paidLeave = data.salaryData.paidLeave
          this.newSalaryData.unPaidLeave = data.salaryData.unPaidLeave
          this.newSalaryData.salaryType = data.salaryData.salaryType
          this.newSalaryData.notes = data.salaryData.notes
          this.newSalaryData.salaryFromDate = data.salaryData.salaryFromDate
          this.newSalaryData.salaryToDate = data.salaryData.salaryToDate
          this.newSalaryData.salary_credit_date = data.salaryData.salaryCreditDate
          this.newSalaryData.payType = data.salaryData.payType
          this.newSalaryData.paidOn = data.salaryData.paidOn
          this.newSalaryData.netPayment = data.salaryData.netPayment
          this.newSalaryData.otherPerks = data.salaryData.otherPerks
          this.newSalaryData.deduction = data.salaryData.deduction
          this.newSalaryData.deductionType = data.salaryData.deduction_type
          this.newSalaryData.perksType = data.salaryData.perks_type
          this.date.setValue(data.salaryData.salaryFromDate)
          this.changeRates()
        }
        
      }

      if(!data.editMode){
        this.loader = true;
        this.loaderservice.showLoader = true
        this._apiService.getOnlySalaryInfo(data.employeeHash, '1')
      }
    this._apiSubscription = this._apiService.apiResult.subscribe((res) => {
      console.log('Response', res);
      if (res.responseType === SM_CONSTANTS.UPLOAD_RESULT) {
        console.log(res.result.url);
        this._ngZone.run(() => {
          this.assetList.push({
            assetName: this.fileName,
            url: res.result?.url,
            thumbnail: res.result?.thumbnail,
          });
          console.log(this.assetList);
          this.loader = false;
        });
        // this.newSalaryData.imgUrl = res.result?.url;fff
      }
      if(res.responseType === SM_CONSTANTS.RESULT_API_GET_SALARY_INFO_ONLY){
        this.salaryData = []
        if(res.result){
          this.newSalaryData.amount = res.result[0].payRate
          this.newSalaryData.deduction = res.result[0].deduction
          this.newSalaryData.otherPerks = res.result[0].otherPerks
          this.newSalaryData.deductionType = res.result[0].deductionType
          this.newSalaryData.perksType = res.result[0].perksType
          this.newSalaryData.netPayment = res.result[0].netPayment
          this.newSalaryData.paidOn = res.result[0].paidOn
          this.newSalaryData.payType = res.result[0].payType
          this.changeRates()
        }
        this.loader = false;
        this.loaderservice.showLoader = false
      }
      if (res.responseType === SM_CONSTANTS.RESULT_API_UPDATE_SALARY_INFO) {
        if(res.result){
          this.parentData.ref.closeAll();
        }
      
      }
    });
  }

  ngOnDestroy() {
    this._apiSubscription.unsubscribe();
  }

  onPost() {
    if(!this.editMode){
      //daily
      if(this.newSalaryData.paidOn == 1){
        let data = {
          salaryInfo : {
            amount: +this.newSalaryData.amount,
            workingDays: +this.newSalaryData.workingDays,
            paidLeave: +this.newSalaryData.paidLeave,
            unPaidLeave: +this.newSalaryData.unPaidLeave,
            deduction: +this.newSalaryData.deduction,
            salaryType: +this.newSalaryData.salaryType,
            notes: this.newSalaryData.notes,
            payType: +this.newSalaryData.payType,
            otherPerks: +this.newSalaryData.otherPerks,
            deductionType: this.newSalaryData.deductionType,
            perksType: this.newSalaryData.perksType,
            netPayment: +this.newSalaryData.netPayment,
            salaryFromDate: this.newSalaryData.salaryFromDate? this.formatDate((new Date(this.newSalaryData.salaryFromDate)).toLocaleDateString()):null,
            salaryToDate: this.newSalaryData.salaryFromDate? this.formatDate((new Date(this.newSalaryData.salaryFromDate)).toLocaleDateString()):null,
            paidOn: +this.newSalaryData.paidOn,
            salary_credit_date: this.newSalaryData.salary_credit_date? this.formatDate((new Date(this.newSalaryData.salary_credit_date)).toLocaleDateString()):null,
          }
         }
         Object.keys(data.salaryInfo).forEach(key => {
          if ((data.salaryInfo as any)[key] === null) {
            delete (data.salaryInfo as any)[key];
          }
        });
         console.log(data);
          this.loaderservice.showLoader = true
          this._apiService.updateSalaryInfo(this.parentData.data.employeeHash,data,'0')
         
      }
      //weekly
      else if(this.newSalaryData.paidOn == 2){
        let data = {
          salaryInfo : {
            amount: +this.newSalaryData.amount,
            workingDays: +this.newSalaryData.workingDays,
            paidLeave: +this.newSalaryData.paidLeave,
            unPaidLeave: +this.newSalaryData.unPaidLeave,
            deduction: +this.newSalaryData.deduction,
            deductionType: this.newSalaryData.deductionType,
            perksType: this.newSalaryData.perksType,
            salaryType: +this.newSalaryData.salaryType,
            notes: this.newSalaryData.notes,
            payType: +this.newSalaryData.payType,
            otherPerks: +this.newSalaryData.otherPerks,
            netPayment: +this.newSalaryData.netPayment,
            salaryFromDate: this.newSalaryData.salaryFromDate? this.formatDate((new Date(this.newSalaryData.salaryFromDate)).toLocaleDateString()):null,
            salaryToDate: this.newSalaryData.salaryToDate? this.formatDate((new Date(this.newSalaryData.salaryToDate)).toLocaleDateString()):null,
            paidOn: +this.newSalaryData.paidOn,
            salary_credit_date: this.newSalaryData.salary_credit_date? this.formatDate((new Date(this.newSalaryData.salary_credit_date)).toLocaleDateString()):null,
          }
         }
         Object.keys(data.salaryInfo).forEach(key => {
          if ((data.salaryInfo as any)[key] === null) {
            delete (data.salaryInfo as any)[key];
          }
        });
         console.log(data);
          this.loaderservice.showLoader = true
       this._apiService.updateSalaryInfo(this.parentData.data.employeeHash,data,'0')
      }
      //monthly
      else if(this.newSalaryData.paidOn == 3){
        let data = {
          salaryInfo : {
            amount: +this.newSalaryData.amount,
            workingDays: +this.newSalaryData.workingDays,
            paidLeave: +this.newSalaryData.paidLeave,
            unPaidLeave: +this.newSalaryData.unPaidLeave,
            deduction: +this.newSalaryData.deduction,
            deductionType: this.newSalaryData.deductionType,
            perksType: this.newSalaryData.perksType,
            salaryType: +this.newSalaryData.salaryType,
            notes: this.newSalaryData.notes,
            payType: +this.newSalaryData.payType,
            otherPerks: +this.newSalaryData.otherPerks,
            netPayment: +this.newSalaryData.netPayment,
            salaryFromDate: this.date.value._d? this.formatDate((new Date(this.date.value._d)).toLocaleDateString()):null,
            salaryToDate: this.date.value._d? this.formatDate((new Date(this.date.value._d)).toLocaleDateString()):null,
            paidOn: +this.newSalaryData.paidOn,
            salary_credit_date: this.newSalaryData.salary_credit_date? this.formatDate((new Date(this.newSalaryData.salary_credit_date)).toLocaleDateString()):null,
          }
         }
         Object.keys(data.salaryInfo).forEach(key => {
          if ((data.salaryInfo as any)[key] === null) {
            delete (data.salaryInfo as any)[key];
          }
        });
         console.log(data);
          this.loaderservice.showLoader = true
       this._apiService.updateSalaryInfo(this.parentData.data.employeeHash,data,'0')
      }
    
    }

    else if (this.editMode){
      
       //daily
      if(this.newSalaryData.paidOn == 1){
        let data = {
          salaryInfo : {
            hash_id: this.newSalaryData.hash_id,
            amount: +this.newSalaryData.amount,
            workingDays: +this.newSalaryData.workingDays,
            paidLeave: +this.newSalaryData.paidLeave,
            unPaidLeave: +this.newSalaryData.unPaidLeave,
            deduction: +this.newSalaryData.deduction,
            deductionType: this.newSalaryData.deductionType,
            perksType: this.newSalaryData.perksType,
            salaryType: +this.newSalaryData.salaryType,
            notes: this.newSalaryData.notes,
            payType: +this.newSalaryData.payType,
            otherPerks: +this.newSalaryData.otherPerks,
            netPayment: +this.newSalaryData.netPayment,
            salaryFromDate: this.newSalaryData.salaryFromDate? this.formatDate((new Date(this.newSalaryData.salaryFromDate)).toLocaleDateString()):null,
            salaryToDate: this.newSalaryData.salaryFromDate? this.formatDate((new Date(this.newSalaryData.salaryFromDate)).toLocaleDateString()):null,
            paidOn: +this.newSalaryData.paidOn,
            salary_credit_date: this.newSalaryData.salary_credit_date? this.formatDate((new Date(this.newSalaryData.salary_credit_date)).toLocaleDateString()):null,
          }
         }
         Object.keys(data.salaryInfo).forEach(key => {
          if ((data.salaryInfo as any)[key] === null) {
            delete (data.salaryInfo as any)[key];
          }
        });
         console.log(data);
          this.loaderservice.showLoader = true
          this._apiService.updateSalaryInfo(this.parentData.data.employeeHash,data,'0')
         
      }
      //weekly
      else if(this.newSalaryData.paidOn == 2){
        let data = {
          salaryInfo : {
            hash_id: this.newSalaryData.hash_id,
            amount: +this.newSalaryData.amount,
            workingDays: +this.newSalaryData.workingDays,
            paidLeave: +this.newSalaryData.paidLeave,
            unPaidLeave: +this.newSalaryData.unPaidLeave,
            deduction: +this.newSalaryData.deduction,
            deductionType: this.newSalaryData.deductionType,
            perksType: this.newSalaryData.perksType,
            salaryType: +this.newSalaryData.salaryType,
            notes: this.newSalaryData.notes,
            payType: +this.newSalaryData.payType,
            otherPerks: +this.newSalaryData.otherPerks,
            netPayment: +this.newSalaryData.netPayment,
            salaryFromDate: this.newSalaryData.salaryFromDate? this.formatDate((new Date(this.newSalaryData.salaryFromDate)).toLocaleDateString()):null,
            salaryToDate: this.newSalaryData.salaryToDate? this.formatDate((new Date(this.newSalaryData.salaryToDate)).toLocaleDateString()):null,
            paidOn: +this.newSalaryData.paidOn,
            salary_credit_date: this.newSalaryData.salary_credit_date? this.formatDate((new Date(this.newSalaryData.salary_credit_date)).toLocaleDateString()):null,
          }
         }
         Object.keys(data.salaryInfo).forEach(key => {
          if ((data.salaryInfo as any)[key] === null) {
            delete (data.salaryInfo as any)[key];
          }
        });
         console.log(data);
          this.loaderservice.showLoader = true
       this._apiService.updateSalaryInfo(this.parentData.data.employeeHash,data,'0')
      }
      //monthly
      else if(this.newSalaryData.paidOn == 3){
        let data = {
          salaryInfo : {
            hash_id: this.newSalaryData.hash_id,
            amount: +this.newSalaryData.amount,
            workingDays: +this.newSalaryData.workingDays,
            paidLeave: +this.newSalaryData.paidLeave,
            unPaidLeave: +this.newSalaryData.unPaidLeave,
            deduction: +this.newSalaryData.deduction,
            deductionType: this.newSalaryData.deductionType,
            perksType: this.newSalaryData.perksType,
            salaryType: +this.newSalaryData.salaryType,
            notes: this.newSalaryData.notes,
            payType: +this.newSalaryData.payType,
            otherPerks: +this.newSalaryData.otherPerks,
            netPayment: +this.newSalaryData.netPayment,
            salaryFromDate: this.date.value._d? this.formatDate((new Date(this.date.value._d)).toLocaleDateString()):null,
            salaryToDate: this.date.value._d? this.formatDate((new Date(this.date.value._d)).toLocaleDateString()):null,
            paidOn: +this.newSalaryData.paidOn,
            salary_credit_date: this.newSalaryData.salary_credit_date? this.formatDate((new Date(this.newSalaryData.salary_credit_date)).toLocaleDateString()):null,
          }
         }
         Object.keys(data.salaryInfo).forEach(key => {
          if ((data.salaryInfo as any)[key] === null) {
            delete (data.salaryInfo as any)[key];
          }
        });
         console.log(data);
          this.loaderservice.showLoader = true
       this._apiService.updateSalaryInfo(this.parentData.data.employeeHash,data,'0')
      }
    }
 

   
  }

  formatDate(originalDate: string): string {
    const parts = originalDate.split('/');
    const day = +parts[0];
    const month = +parts[1] - 1; // Months are 0-based in JavaScript
    const year = +parts[2];
    const date = new Date(year, month, day);
  
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0'); // Adding 1 to month since it's 0-based
    const dd = String(date.getDate()).padStart(2, '0');
  
    return `${yyyy}-${mm}-${dd}`;
  }

  formatDateForEdit(originalDate: string) {
    const date = new Date(originalDate);
    
    const yyyy = date.getUTCFullYear();
    const mm = String(date.getUTCMonth() + 1).padStart(2, '0'); // Adding 1 to month since it's 0-based
    const dd = String(date.getUTCDate()).padStart(2, '0');
  
    return `${yyyy}-${mm}-${dd}`;
  }

  setMonthAndYear(normalizedMonthAndYear: Moment, datepicker: MatDatepicker<Moment>) {
    const ctrlValue = this.date.value ?? moment();
    ctrlValue.month(normalizedMonthAndYear.month());
    ctrlValue.year(normalizedMonthAndYear.year());
    console.log(ctrlValue);
    
    this.date.setValue(ctrlValue);
    console.log(this.date.value._d);
    
    datepicker.close();
  }

  changeRates(){
    setTimeout(() => {
    this.newSalaryData.np = (+this.newSalaryData.netPayment) + (+this.newSalaryData.otherPerks) - (+this.newSalaryData.deduction)
      
    }, 0);
    
  }
}
